import React from 'react';
import * as R from 'ramda';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import type { IssueColumnStateV0 } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/view-settings/field-columns/types';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { statusBreakdownColourMap } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/colours';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import messages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/status-breakdown/components/messages';
import LegendContainer from '../legend-container';
import LegendItems from '../legend-items';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../styles.module.css';
import type { Props } from './types';

function StatusBreakdownLegend({
	intl,
	fieldColumnsViewSettings,
}: Props & {
	intl: IntlShape;
}) {
	// Don't show this legend if status breakdown column is not visible
	if (R.isEmpty(fieldColumnsViewSettings) || R.isEmpty(fieldColumnsViewSettings.columns)) {
		return null;
	}
	const breakdownColumn = R.find<IssueColumnStateV0>(
		R.propEq<'id', string | number>('id', 'breakdown'),
	)(fieldColumnsViewSettings.columns);

	if (!isDefined(breakdownColumn) || !breakdownColumn?.isVisible) {
		return null;
	}

	const legendItems = [
		{
			icon: (
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styles.legendItemColor}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					style={{ backgroundColor: statusBreakdownColourMap.TODO }}
				/>
			),
			text: intl.formatMessage(messages.todo),
		},
		{
			icon: (
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styles.legendItemColor}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					style={{ backgroundColor: statusBreakdownColourMap.INPROGRESS }}
				/>
			),
			text: intl.formatMessage(messages.inprogress),
		},
		{
			icon: (
				<div
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className={styles.legendItemColor}
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					style={{ backgroundColor: statusBreakdownColourMap.DONE }}
				/>
			),
			text: intl.formatMessage(messages.done),
		},
	];

	return (
		<LegendContainer title={intl.formatMessage(commonMessages.statusBreakdown)}>
			<LegendItems items={legendItems} />
		</LegendContainer>
	);
}

export default injectIntl(StatusBreakdownLegend);
